import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'faire_direct-pop_foi_modal_on_page_nav-action_category_other';

/**
 * Fires when the FOI modal is made to pop automatically on page navigation via the useFaireDirectPopFoiModalOnPageNavEffect.
 */
export function trackFaireDirectPopFoiModalOnPageNavActionCategoryOther(): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
  });
}
